import * as React from 'react';
import { TextileHelper } from '../../../../ts/helpers/TextileHelper';
import { ServiceLocator } from '../../../ServiceLocator';
import { DetailsTooltipStyles } from '../../CardView/DetailsTooltipStyles';
import { ContentDescriptionClassNames } from '../TooltipHelper';

export interface MarkupFieldProps {
  label?: string;
  markup: string;
  testId?: string;
  extraClasses?: string[];
}

export function MarkupField(props: MarkupFieldProps) {
  const sanitizeFn = ServiceLocator.get<ng.sanitize.ISanitizeService>('$sanitize');
  const htmlContent = getSanitizedHtmlFromMarkup(props.markup, sanitizeFn);

  if (!props.markup || !htmlContent) {
    return null;
  }

  const classes = [DetailsTooltipStyles.MetadataSection].concat(props.extraClasses).join(' ');

  return (
    <div className={classes}
         data-tb-test-id={props.testId || 'tooltip-markup-field'}>

      { props.label && <div className={DetailsTooltipStyles.MultiLineTitle}>{props.label}</div> }

      <div className={ContentDescriptionClassNames}
           dangerouslySetInnerHTML={htmlContent} />

    </div>
  );
}

function getSanitizedHtmlFromMarkup(
  markup: string,
  sanitizeFn: ng.sanitize.ISanitizeService
): { __html: string } {
  return { __html: TextileHelper.getSanitizedHtmlFromTextile(markup, sanitizeFn) };
}
